import React from "react";
// import { Button } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";
import { addWodModal } from "../../redux/actions/sidebar/sidebarAction";
import { store } from "../../redux/storeConfig/store";
import { history } from "../../app/AppRouter";
import { voiceReviewActionLabel } from "../voiceAdd/saveDraftEdit";

export const StepButton = (props) => {
  const { step } = props;
  switch (step) {
    case 1:
      return (
        <>
          <div className="action-wrapper blk-padding-y">
            <div className="action-inner-block">
              <div className="action-btn-block">
                <button
                  className="btn btn-medium btn-transparent"
                  onClick={() => {
                    store.dispatch(addWodModal(false));
                    // history.push('/gym-panel/wod');
                  }}
                >
                  Cancel
                </button>
                <button value="Next" className="btn btn-medium">
                  Next
                </button>
              </div>
            </div>
          </div>
        </>
      );
    case 2:
      return (
        <>
          <div className="action-wrapper blk-padding-y">
            <div className="action-inner-block">
              <div className="action-btn-block">
                <button
                  value="Previous"
                  className="btn btn-medium btn-transparent"
                  onClick={(e) => {
                    e.preventDefault();
                    props.previous();
                  }}
                >
                  Previous
                </button>
                <button
                  value="Add Workout"
                  className="btn btn-medium"
                  type="submit"
                >
                  {/* Create WOD */}
                  {voiceReviewActionLabel(
                    `${props.edit ? "Update" : "Add"} Workout`
                  )}
                </button>
              </div>
            </div>
          </div>
        </>
      );
    default:
      return <></>;
  }
};
